const fetchGet = (url: string, options?: RequestInit) => {
  return fetch(url, {
    ...options,
    method: "GET",
    headers: {
      ...options?.headers,
    },
  });
};

const fetchPost = (url: string, options: RequestInit) => {
  return fetch(url, {
    ...options,
    method: "POST",
    headers: {
      ...options.headers,
    },
  });
};

const fetchPut = (url: string, options?: RequestInit) => {
  return fetch(url, {
    ...options,
    method: "PUT",
    headers: {
      ...options?.headers,
    },
  });
};

export { fetchGet, fetchPost, fetchPut };
